import { LOCALIZE_NAME_OPTIONS } from "~/constans/commom";

export const localizedSortFieldForApi = (
  option: string,
  lang: string | null | undefined,
) =>
  lang === "en" && LOCALIZE_NAME_OPTIONS.includes(option)
    ? `${option}En`
    : option;

export const getLocalizedSortableApiKeys = (
  options: string[],
  lang: string | null | undefined,
) => options.map((option) => localizedSortFieldForApi(option, lang));
